import { request } from '@utils';
import { LIMIT } from '@constants';

const getB2BOrders = async (payload = {}) => {
  if (!payload?.page) {
    payload.page = 1;
  }
  if (!payload?.pageSize) {
    payload.pageSize = LIMIT;
  }
  const results = await request.get(`/v1/rac/orders`, payload);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getB2BOrder = async (id) => {
  const results = await request.get(`/v1/rac/orders/${id}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateOrder = async (payload = {}) => {
  const params = {
    body: payload,
  };

  const results = await request.post(`/v1/rac/orders`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addB2BOrder = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/rac/orders`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBookingProducts = async (payload = {}) => {
  const params = new URLSearchParams({
    offset: 1,
    limit: 10000,
    orderBy: 'is_active',
    order: 'asc',
    // catalogId: payload.catalogId,
    // contractPeriod: payload.contractPeriod,
    ...payload,
  });

  const results = await request.get(`/v1/rac/orders/products?${params}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const sendMail = async (id) => {
  const results = await request.get(`/v1/rac/orders/${id}/send-offer`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  getB2BOrders,
  updateOrder,
  addB2BOrder,
  getB2BOrder,
  getBookingProducts,
  sendMail,
};
